import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'This field is required.'
});
extend('email', email);

extend('min', {
  validate(value, { length }) {
    return value.length >= length;
  },
  params: ['length'],
  message: '{_field_} must have at least {length} characters'
});

extend('max', {
  validate(value, { length }) {
    return value.length <= length;
  },
  params: ['length'],
  message: '{_field_} may not be greater than {length} characters'
});

extend('minRange', {
  validate(value, { range }) {
    value = value || 0
    return value >= range;
  },
  params: ['range'],
  message: '{_field_} must be at least {range}'
});

extend('match', {
  validate(value, { val }) {
    return value === val;
  },
  params: ['val'],
  message: '{_field_} must match'
});

extend('phoneNumber', {
  validate(value) {
    return value && value.match(/\d/g).length < 17
  },
  message: 'The phone number may not be greater than 16 characters'
});

extend('number', {
  validate(value) {
    return value && value.match(/^[0-9]*(\.\d*)?$/g)
  },
  message: '{_field_} must be a number'
});

extend('decimal', {
  validate(value) {
    return value && value.match(/^\d*(\.\d{1,2})?$/g)
  },
  message: '{_field_} must be a maximum of 2 decimal places. e.g. 5.50'
});

export default {
  install (Vue) {
    Vue.component('ValidationProvider', ValidationProvider)
    Vue.component('ValidationObserver', ValidationObserver)
  }
}